import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { AppDispatch } from "../../../.."
import { BUILD_TIME_STAMP } from "../../../../constant/constant"
import {
  loginByQRCodePage,
  selectModePage,
} from "../../../../constant/tablet/pages"
import { tenkosyaLoginByPassCode } from "../../../../globalStore/authStore"
import { ReactComponent as UpdateIcon } from "../../../../source/img/icons/update_black_24dp.svg"
import loginPageImage from "../../../../source/img/login_page_image.png"
import { sleep } from "../../../../ts/hooks/useRFC380Reader"
import useSyainCardReader from "../../../../ts/hooks/useSyainCardReader"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import { showWarnToast } from "../../../../components/Tablet/TabletToast"
import {
  changeWebApp,
  checkWindows,
} from "../../../../globalStore/terminalStore"
import { RootState } from "../../../../globalStore/rootreducer"

const TabletLogin = () => {
  const history = useHistory()

  const isWindows = useSelector((state: RootState) => state.terminal.isWindows)

  const dispatch: AppDispatch = useDispatch()
  const { NfcCardReader, deviceStatus, scanCardReader, NFCReadOFF } =
    useSyainCardReader(async (cardId) => {
      try {
        await dispatch(tenkosyaLoginByPassCode({ パスコード: cardId }))
        history.push(selectModePage.Route.path)
      } catch (error) {
        showWarnToast("点呼者のカードであるか確認をお願いします。")

        scanCardReader()
      }
    })

  const 社員証入力ButtonClickHandler = async (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.preventDefault()
    e.stopPropagation()
    NFCReadOFF()

    do {
      await sleep(10)
    } while (NfcCardReader?.opened)

    history.push(loginByQRCodePage.Route.path)
  }

  navigator.userAgentData
    .getHighEntropyValues(["platformVersion"])
    .then((ua) => {
      dispatch(checkWindows(navigator.userAgentData.platform === "Windows"))
    })

  return (
    <>
      <div className="h-100 text-center pt-2">
        <div onTouchEnd={scanCardReader}>
          {NfcCardReader == null ? (
            <>
              <h1 className="text-danger mt-5">
                カードリーダ－が認識できませんでした。
              </h1>
              <h1 className="text-danger">
                画面をタッチしてカードリーダーを認識させてください。
              </h1>
            </>
          ) : (
            <h1 className="mt-5">
              {deviceStatus
                ? "点呼者の社員証をカードリーダーにタッチしてください。"
                : "画面をタッチして読取モードにしてください"}
            </h1>
          )}
          <div className="text-center mx-auto align-middle p-5 h-40rem">
            <div className="h-100">
              <img style={{ height: "100%" }} src={loginPageImage} alt=""></img>
            </div>
            {NfcCardReader != null && (
              <div style={{ fontSize: "1rem" }}>
                {!deviceStatus ? "読取モード停止中..." : "カード読取中..."}
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: "2rem",
            right: "1rem",
            fontSize: "2rem",
            padding: "1rem",
            border: CSS_PROPERTY.BORER_PROP,
            backgroundColor: "white",
          }}
          onClick={社員証入力ButtonClickHandler}>
          QRコードを読み取る
        </div>
        <div
          style={{
            position: "absolute",
            bottom: "2rem",
            left: "1rem",
            fontSize: "1rem",
            padding: "1rem",
          }}>
          <p>ver.{BUILD_TIME_STAMP}</p>
          <p
            onClick={async (e) => {
              e.preventDefault()
              e.stopPropagation()
              NFCReadOFF()

              do {
                await sleep(10)
              } while (NfcCardReader?.opened)

              window.location.reload()
            }}>
            <UpdateIcon />
            アプリを更新する
          </p>
        </div>
        {isWindows && (
          <div
            onClick={async (e) => {
              e.preventDefault()
              e.stopPropagation()
              dispatch(changeWebApp())
            }}
            style={{
              position: "absolute",
              bottom: "2rem",
              left: "50%",
              fontSize: "2rem",
              padding: "1rem",
              border: CSS_PROPERTY.BORER_PROP,
              backgroundColor: "white",
            }}>
            KAIROSを表示する
          </div>
        )}
      </div>
    </>
  )
}

export default TabletLogin
